import { render, staticRenderFns } from "./JobListingCandidateHistory.vue?vue&type=template&id=38bd9019"
import script from "./JobListingCandidateHistory.vue?vue&type=script&lang=js"
export * from "./JobListingCandidateHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38bd9019')) {
      api.createRecord('38bd9019', component.options)
    } else {
      api.reload('38bd9019', component.options)
    }
    module.hot.accept("./JobListingCandidateHistory.vue?vue&type=template&id=38bd9019", function () {
      api.rerender('38bd9019', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/JobListingCandidateHistory.vue"
export default component.exports